import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Api, Session } from '../services/index';
@Component({
  selector: 'app-dashboard-how-it-works',
  templateUrl: './dashboard-how-it-works.html'
})
 


export class DashboardHowItWorks  {
  constructor(private router: Router,
      public session: Session,
    private sanitizer: DomSanitizer) { 
      if(this.session.intakeLob === 'BH'){
        this.router.navigateByUrl('/bh-how-it-works');
      }
  }

  // continue(){
  //   this.router.navigateByUrl('/dashboard-medical/1');
  // }
	requestExam(){
		this.router.navigateByUrl('/exam-request-care-today');
  }
  
  gotoDashboard() {
		this.router.navigate(['/dashboard-medical/1']);
	}

  cleanURL(oldURL : string): SafeResourceUrl{
	  if (oldURL) {
		return this.sanitizer.bypassSecurityTrustResourceUrl(oldURL);
	  }
	  return oldURL;
	}
}